(function () {
    'use strict';
  
    function initMtShowSection() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        setTimeout(initMtShowSection, 100);
        return;
      }
  
      gsap.registerPlugin(ScrollTrigger);
  
      var sections = document.querySelectorAll('.mt-show-section');
      if (!sections.length) return;
  
      sections.forEach(function (section) {
        setupDesktopScroll(section);
      });
    }
  
    function setupDesktopScroll(section) {
      if (window.innerWidth <= 750) return;
  
      var mediaPanel = section.querySelector('.mt-show-media-panel');
      var images = Array.prototype.slice.call(
        section.querySelectorAll('.mt-show-image')
      );
      var contentItems = Array.prototype.slice.call(
        section.querySelectorAll('.mt-show-content-item')
      );
  
      if (!mediaPanel || !images.length || !contentItems.length) return;
  
      // 默认显示第一个 block 内容，但初始隐藏整个内容面板（等图片缩小后才显示）
      var currentBlockIndex = 0;
      contentItems.forEach(function (itemEl, idx) {
        if (idx === 0) {
          itemEl.classList.add('mt-show-content-item--active');
        } else {
          itemEl.classList.remove('mt-show-content-item--active');
        }
      });
      
      // 初始化时隐藏左侧内容面板
      var contentPanel = section.querySelector('.mt-show-content-panel');
      if (contentPanel) {
        gsap.set(contentPanel, { opacity: 0 });
      }
  
      // 构建 slide 列表（按 slide-index 排序）
      var slides = images
        .map(function (imgEl) {
          var slideIndex = parseInt(
            imgEl.getAttribute('data-slide-index') || '0',
            10
          );
          var blockIndex = parseInt(
            imgEl.getAttribute('data-block-index') || '0',
            10
          );
          var imageOrder = parseInt(
            imgEl.getAttribute('data-image-order') || '0',
            10
          );
          var blockTotal = parseInt(
            imgEl.getAttribute('data-block-total') || '0',
            10
          );
          return {
            el: imgEl,
            slideIndex: slideIndex,
            blockIndex: blockIndex,
            imageOrder: imageOrder,
            blockTotal: blockTotal
          };
        })
        .sort(function (a, b) {
          return a.slideIndex - b.slideIndex;
        });
  
      var totalSlides = slides.length;
      if (!totalSlides) return;
  
      // 右下角计数器
      var counterEl = section.querySelector('.mt-show-counter');
      var counterCurrentEl = section.querySelector('.mt-show-counter-current');
      var counterTotalEl = section.querySelector('.mt-show-counter-total');
  
      // 初始：第一张图在可视区域，其余在底部准备上滑
      slides.forEach(function (slide, idx) {
        if (idx === 0) {
          slide.el.style.transform = 'translate3d(0, 0%, 0)';
          slide.el.style.zIndex = String(10 + idx);
        } else {
          slide.el.style.transform = 'translate3d(0, 100%, 0)';
          slide.el.style.zIndex = String(10 + idx);
        }
      });
  
      // 初始化计数器为第一张图片对应的序号和总数
      if (counterEl && counterCurrentEl && counterTotalEl) {
        var first = slides[0];
        var initialOrder = first.imageOrder || 1;
        var initialTotal = first.blockTotal || 1;
        counterCurrentEl.textContent = String(initialOrder);
        counterTotalEl.textContent = String(initialTotal);
        counterEl.style.display = initialTotal > 1 ? 'inline-flex' : 'none';
      }
  
      // 高度：进入全屏 → 固定区间（英雄缩放 + 所有图片切换）→ 离开恢复普通滚动
      // end 距离：首阶段 1 屏 + 每张图片 0.8 屏
      var pinDuration = 1 + totalSlides * 0.8;
      var heroPhase = 0.2; // 前 20% 用于首张图从满屏缩放到右侧 50%、左侧文字淡入
  
      // 主 ScrollTrigger
      ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: '+=' + window.innerHeight * pinDuration,
        pin: section.querySelector('.mt-show-desktop'),
        pinSpacing: true,
        scrub: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          var progress = self.progress || 0;
          progress = Math.max(0, Math.min(1, progress));
  
          // ===== 阶段 1：首张图满屏 → 缩到右侧 50% =====
          var heroProgress = 0;
          if (progress <= heroPhase) {
            heroProgress = progress / heroPhase;
          } else {
            heroProgress = 1;
          }
  
          // 宽度从 100vw → 50vw，靠右缩小，高度保持 100%，通过裁切两侧避免变形
          var widthPercent = 100 - heroProgress * 50; // 100 → 50
          widthPercent = Math.max(50, widthPercent);
          gsap.set(mediaPanel, {
            width: widthPercent + 'vw',
            right: 0
          });
  
          // 左侧内容容器：在 hero 阶段完成后才显示（等图片缩小固定在右边）
          var contentPanel = section.querySelector('.mt-show-content-panel');
          if (contentPanel) {
            var contentOpacity = progress > heroPhase ? 1 : 0;
            gsap.set(contentPanel, { opacity: contentOpacity });
            // toggle class to allow staggered reveal only when panel is shown
            if (progress > heroPhase) {
              contentPanel.classList.add('mt-show-content-panel--shown');
            } else {
              contentPanel.classList.remove('mt-show-content-panel--shown');
            }
          }
  
          // ===== 阶段 2：图片驱动滚动 + 文案联动 =====
          if (totalSlides <= 1) return;
  
          // ===== 图片覆盖滚动：随着滚动速度从下往上覆盖 =====
          var slidesProgress = 0;
          if (progress > heroPhase) {
            slidesProgress = (progress - heroPhase) / (1 - heroPhase);
            slidesProgress = Math.max(0, Math.min(1, slidesProgress));
          } else {
            slidesProgress = 0;
          }
  
          var maxIndex = totalSlides - 1;
          var raw = slidesProgress * maxIndex; // 0 ~ maxIndex
          var segIndex = Math.floor(raw);      // 当前段起点索引
          var local = raw - segIndex;          // 当前段内 0~1
  
          // 防御：确保索引合法
          if (segIndex < 0) {
            segIndex = 0;
            local = 0;
          }
          if (segIndex >= maxIndex) {
            segIndex = maxIndex;
            local = 1;
          }
  
          slides.forEach(function (slide, idx) {
            var yPercent = 100;
  
            if (slidesProgress <= 0) {
              // 还没到图片序列区域：第一张图完全显示，其余在底部
              yPercent = idx === 0 ? 0 : 100;
            } else if (slidesProgress >= 1) {
              // 已经滚完所有图片段：所有图片都停在 0，后面的自然在上层
              yPercent = 0;
            } else {
              if (idx <= segIndex) {
                // 当前段之前的所有图片都已固定在顶部
                yPercent = 0;
              } else if (idx === segIndex + 1) {
                // 正在上来的那一张：从 100% → 0%
                yPercent = (1 - local) * 100;
              } else {
                // 之后的图片还在底部等待
                yPercent = 100;
              }
            }
  
            slide.el.style.transform =
              'translate3d(0,' + yPercent.toFixed(3) + '%,0)';
            slide.el.style.zIndex = String(10 + idx);
          });
  
          // 根据当前“逻辑 slide”所属 block，联动左侧文案 + 右下角计数器
          var logicalIndex = Math.round(raw);
          logicalIndex = Math.max(0, Math.min(maxIndex, logicalIndex));
          var currentSlide = slides[logicalIndex];
          var targetBlockIndex = currentSlide.blockIndex;
          if (targetBlockIndex !== currentBlockIndex) {
            currentBlockIndex = targetBlockIndex;
            updateActiveContent(contentItems, currentBlockIndex);
          }
  
          if (counterEl && counterCurrentEl && counterTotalEl) {
            var order = currentSlide.imageOrder || 1;
            var total = currentSlide.blockTotal || 1;
            counterCurrentEl.textContent = String(order);
            counterTotalEl.textContent = String(total);
            counterEl.style.display = total > 1 ? 'inline-flex' : 'none';
          }
        }
      });
    }
  
    function updateActiveContent(contentItems, activeBlockIndex) {
      contentItems.forEach(function (itemEl) {
        var blockIndex = parseInt(
          itemEl.getAttribute('data-block-index') || '0',
          10
        );
        if (blockIndex === activeBlockIndex) {
          itemEl.classList.add('mt-show-content-item--active');
        } else {
          itemEl.classList.remove('mt-show-content-item--active');
        }
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMtShowSection);
    } else {
      initMtShowSection();
    }
  
    window.addEventListener('resize', function () {
      // 重新初始化（简单处理：刷新 ScrollTrigger）
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    });
  })();
  
  
  